import React from 'react'
import { Heading } from 'theme-ui'

/**
 * Shadow me to add your own content
 */

const styles = {
  heading: {
    span: {
      color: `omegaDark`
    }
  }
}

const HeroLeft = () => (
  <Heading variant='h1' sx={styles.heading}>
    Be informed
    <br />
    <span>Stay Safe</span>
  </Heading>
)
export default HeroLeft